import React, { useRef } from "react";
import Header2 from "../components/Header2";
import Apply from "../components/Apply/Apply";
import Carousel from "../components/Carousel/Carousel";
import Footer from "../components/Footer";

function FormPage() {
  const introRef = useRef(null);
  const scheduleRef = useRef(null);
  const faqRef = useRef(null);
  const checkRef = useRef(null);

  return (
    <div>
      <Header2
        introRef={introRef}
        scheduleRef={scheduleRef}
        faqRef={faqRef}
        checkRef={checkRef}
      />
      <main>
        <Apply />
        <Carousel />
      </main>
      <Footer />
    </div>
  );
}

export default FormPage;
